module.exports = __webpack_public_path__ + "img/living-checked.311a5a4c.jpg";